<template>
  <ux-form
    ref="form"
    class="instructions"
    width="500px"
    label-width="56px"
    data-automation="instructions"
    :data="formData"
    :colon="true"
    :rules="rules"
    @close="close"
    @confirm="confirm"
  >
    <ux-form-item :label="$t('HT.instructions')" required prop="zhilin">
      <ux-input v-model="formData.zhilin" :placeholder="$t('HT.instructions.placeholder')"></ux-input>
    </ux-form-item>
    <ux-form-item :label="$t('HT.remark')" required start prop="remark">
      <ux-input v-model="formData.zhilin" type="textarea" :placeholder="$t('HT.remark.placeholder')"></ux-input>
    </ux-form-item>
    <ux-form-item :label="$t('HT.devicesList')" required start prop="device">
      <ux-input v-model="formData.device" type="textarea"></ux-input>
    </ux-form-item>
  </ux-form>
</template>

<script>
export default {
  props: {
    data: {
      type: Object,
      default: () => {
        return {
          zhilin: '',
          remark: '',
          device: ''
        };
      }
    }
  },

  data() {
    return {
      formData: JSON.parse(JSON.stringify(this.data)),
      rules: this.$rul.addGroup()
    };
  },

  methods: {
    /**
     * 取消回调
     */
    close() {
      this.$uxModal.hide();
    },

    /**
     * 确认回调
     */
    confirm() {
      this.$emit('confirm', this.formData);
    }
  }
};
</script>
